<!-- Consent Popup for Client UserRole only -->
<div class="consent_popup" *ngIf="userConsent=='no' && userRole === 'Client'">
  <div class="consent_popup_content">
    <h3>{{noticeHeading}}</h3>
    <p style="white-space: pre-line;" [innerHTML]="noticeContent"></p>
    
    <div class="consent_footer">
      <label><input type="checkbox" #acceptTerms> {{"HaveRead" | translate}}</label>
      <button class="btn btn-primary btn-sm" (click)="giveConsent(acceptTerms.checked)">OK</button>
    </div>
  </div>
</div>

<!---------------------- Email Setting Update pop up ----------------------> 
<div class="email-accept" *ngIf="emailSuccess">
  <div class="email-accept_content" *ngIf="lang === 'jp'">
    <h3>メールアドレス更新完了</h3>
    <p>認証が完了し、新しいメールアドレスが登録されました。</p>
    <p>今後の通知や連絡は、新しいメールアドレスに送信されます。</p>
    <div class="consent_footer">
      <button class="btn btn-primary" (click)="close()">OK</button>
    </div>
  </div>
  <div class="email-accept_content" *ngIf="lang === 'en'">
    <h3>Accept email changes</h3>
    <p>Your identity has been verified.</p>
    <p>You will receive email notifications.</p>
    <div class="consent_footer">
      <button class="btn btn-primary" (click)="close()">OK</button>
    </div>
  </div>

</div>
<!--------------------------------------END Pop up ------------------------->

<!--  ############### Top Select Month Start ################# -->
<div class="select_month_section">
	<section class="row">
		<div class="select_month col-auto">
			<h2><label for="select_year_month">{{"SELECTMONTH" | translate}}</label> </h2>
			<select 
			class="form-select" 
			aria-label="Month selection"
            [(ngModel)]="dropDowndate"
			(change)="fncCng($event)">
				<option *ngFor="let date of monthDropdown" [value]="date.dayDate">
					<!-- {{ "DDMONTH."+getMonth(date) | translate}} {{getYear(date)}} -->
                      {{(lang == 'en') ? date.eNdate: date.jPdate}}
				</option>
			</select>
			<ng-container *ngIf="adminLevel === 0">
				<h2 class="pl20">{{'CompanyName' | translate}}:</h2>
				<p>{{companyName}}</p>
			</ng-container>
		</div>
<!--
		<div class="col-auto co_name">
			<h2>{{"CompanyName" | translate}}:</h2>
			<p>{{companyName}}</p>
		</div>
-->		
		<!-- <div class="summary col-auto gap-2"> -->
			<!-- <div class="download_dropdown"> -->
                <div class="download_dropdown">
				<!-- <a href="download-attendance-summary/{{timeSheetDate}}"><button class="btn btn-primary btn-sm"><i class="bi bi-download"></i> {{"Home.Download" | translate}}</button></a> -->
				<!-- <ul>
					<li><a href="#">Bulk Download Management Ledger</a> </li>
					<li><a href="#">Download Attendance Data</a> </li>
					<li><a href="download-attendance-summary">{{"Home.DwnMainMenu" | translate}}</a> </li>
					<li><a href="download-contract-details">{{"Home.DwnContractList" | translate}}</a> </li>
				</ul> -->
			</div>
			
			<!-- <button class="btn btn-primary btn-sm"><i class="bi bi-check2-all"></i> Approve All</button> -->
		<!-- </div> -->
		</section>
</div>
<!--  ############### Top Select Month End ################# -->
<!--  ############### Middle Containt Area Start ################# -->
<div class="container_wrapper">
	
	<!-- Search Filter -->
	<div class="filter_section">
		<label>{{"SearchByText" | translate}}:</label>
		<input type="text" class="form-control" (input)="onSearchFilter($event)" placeholder="{{'SearchKey' | translate}}" />
	</div>
	
	<!--  ############### Data Table Start ################# -->
	<div class="client_associate_list" [class.lang-jp]="lang === 'jp'" [class.lang-en]="lang === 'en'" [class.admin-view]="adminLevel > 0">
		
		<!-- Desktop Table Header -->
		<div class="associate_table_heading desktop-header">
			<section>
				<article>
					<ng-container *ngIf="adminLevel === 0">
						<div class="tbl_section">{{'AssociatesList.Section' | translate}}</div>					
						<div class="tbl_ucode">登録番号</div>						
						<div class="tbl_name">{{'AssociatesList.Name' | translate}}</div>
						<div class="tbl_regular">{{'AssociatesList.REGULAR' | translate}}</div>
						<div class="tbl_overtime">{{'AssociatesList.OVERTIME' | translate}}</div>
						<div class="tbl_midnight">{{'AssociatesList.MIDNIGHT' | translate}}</div>
						<div class="tbl_total">{{'AssociatesList.TOTAL' | translate}}</div>
						<div class="tbl_notsubmit">{{'AssociatesList.NOTSUBMIT' | translate}}</div>
						<div class="tbl_submit">{{'AssociatesList.SUBMIT' | translate}}</div>
						<div class="tbl_reject">{{'AssociatesList.REJECT' | translate}}</div>
						<div class="tbl_approve">{{'AssociatesList.APPROVE' | translate}}</div>
						<div class="tbl_home">{{'AssociatesList.home' | translate}}</div>
						<div class="tbl_absence">{{'AssociatesList.Absence' | translate}}</div>
						<div class="tbl_paid">{{'AssociatesList.PaidHoliday' | translate}}</div>
						<div class="tbl_contract">{{'AssociatesList.ContractTerm' | translate}}</div>
						<div class="tbl_download">{{'AssociatesList.SUM' | translate}}</div>
						<div class="tbl_ledger">{{'AssociatesList.LEDGER' | translate}}</div>
					</ng-container>
					<ng-container *ngIf="adminLevel > 0">
						<div class="tbl_admin_company">会社名</div>
						<div class="tbl_admin_office">部課名</div>
						<div class="tbl_admin_ucode">登録番号</div>
						<div class="tbl_name">{{'AssociatesList.Name' | translate}}</div>
						<div class="tbl_notsubmit">{{'AssociatesList.NOTSUBMIT' | translate}}</div>
						<div class="tbl_submit">{{'AssociatesList.SUBMIT' | translate}}</div>
						<div class="tbl_reject">{{'AssociatesList.REJECT' | translate}}</div>
						<div class="tbl_approve">{{'AssociatesList.APPROVE' | translate}}</div>
						<div class="tbl_contract">{{'AssociatesList.ContractTerm' | translate}}</div>
						<div class="tbl_download">{{'AssociatesList.SUM' | translate}}</div>
						<div class="tbl_ledger">{{'AssociatesList.LEDGER' | translate}}</div>
					</ng-container>
				</article>
			</section>
		</div>
		
		<!-- Mobile Table Header -->
		<div class="associate_table_heading_mobile mobile-header">
			<aside>
				<ng-container *ngIf="adminLevel === 0">
					<div class="tbl_expand">{{"EXPAND" | translate}}</div>				
					<div class="tbl_ucode">登録番号</div>					
					<div class="tbl_name">{{'AssociatesList.Name' | translate}}</div>
					<div class="tbl_notsubmit">未</div>
					<div class="tbl_submit">報</div>
					<div class="tbl_reject">否</div>
					<div class="tbl_approve">認</div>
				</ng-container>
				<ng-container *ngIf="adminLevel > 0">
					<div class="tbl_expand">{{"EXPAND" | translate}}</div>
					<div class="tbl_name">{{'AssociatesList.Name' | translate}}</div>
					<div class="tbl_admin_ucode">登録番号</div>
				</ng-container>
			</aside>
		</div>
		
		<!-- No Data Message -->
		<div class="empty_message" *ngIf="!isLoading && visibleData.length === 0">
			<p>{{"NoListFound" | translate}}</p>
		</div>
		
		<!-- Data Rows -->
		<ng-container *ngFor="let item of visibleData; let i = index">
			<ng-container *ngFor="let asso of item.summaries; let s_i = index">
				<div class="associate_row">
					<section>
						<aside>
							<ng-container *ngIf="adminLevel === 0">
								<div class="tbl_expand">
									<button class="expand" [class.active]="expandedRows[i + '_' + s_i]" (click)="toggleRow(i + '_' + s_i)"></button>
								</div>
								<div class="tbl_ucode">{{asso.userCode}}</div>
								<div class="tbl_name">
									<a href="client-timesheet/{{asso.timesheetID}}/{{asso.userId}}" class="dlt_link">{{asso.userName}}</a>
								</div>
								<div class="tbl_notsubmit">{{asso.notSubmit}}</div>
								<div class="tbl_submit">{{asso.submit}}</div>
								<div class="tbl_reject">{{asso.reject}}</div>
								<div class="tbl_approve">{{asso.approve}}</div>
							</ng-container>
							<ng-container *ngIf="adminLevel > 0">
								<div class="tbl_expand">
									<button class="expand" [class.active]="expandedRows[i + '_' + s_i]" (click)="toggleRow(i + '_' + s_i)"></button>
								</div>
								<div class="tbl_name">
									<a href="client-timesheet/{{asso.timesheetID}}/{{asso.userId}}" class="dlt_link">{{asso.userName}}</a>
								</div>
							<div class="tbl_admin_ucode">{{asso.userCode}}</div>
						</ng-container>
						</aside>
						<article [ngClass]="{ 'expanded': expandedRows[i + '_' + s_i] }">
							<ng-container *ngIf="adminLevel === 0">
							<div class="tbl_section">{{item.customerOfficeName}}</div>						
							<div class="tbl_ucode">
								<samp>登録番号</samp>
								<span>{{asso.userCode}}</span>
							</div>							
							<div class="tbl_name">
								<samp>{{'AssociatesList.Name' | translate}}</samp>
								<a href="client-timesheet/{{asso.timesheetID}}/{{asso.userId}}" class="dlt_link">{{asso.userName}}</a>
							</div>
							<div class="tbl_regular">
								<samp>{{'AssociatesList.REGULAR' | translate}}</samp>
								<span>{{asso.regular}}</span>
							</div>
							<div class="tbl_overtime">
								<samp>{{'AssociatesList.OVERTIME' | translate}}</samp>
								<span>{{asso.overtime}}</span>
							</div>
							<div class="tbl_midnight">
								<samp>{{'AssociatesList.MIDNIGHT' | translate}}</samp>
								<span>{{asso.midnightOvertime}}</span>
							</div>
							<div class="tbl_total">
								<samp>{{'AssociatesList.TOTAL' | translate}}</samp>
								<span>{{asso.total}}</span>
							</div>
							<div class="tbl_notsubmit">
								<samp>{{'AssociatesList.NOTSUBMIT' | translate}}</samp>
								<span>{{asso.notSubmit}}</span>
							</div>
							<div class="tbl_submit">
								<samp>{{'AssociatesList.SUBMIT' | translate}}</samp>
								<span>{{asso.submit}}</span>
							</div>
							<div class="tbl_reject">
								<samp>{{'AssociatesList.REJECT' | translate}}</samp>
								<span>{{asso.reject}}</span>
							</div>
							<div class="tbl_approve">
								<samp>{{'AssociatesList.APPROVE' | translate}}</samp>
								<span>{{asso.approve}}</span>
							</div>
							<div class="tbl_home">
								<samp>{{'AssociatesList.home' | translate}}</samp>
								<span>{{asso.teleWork}}</span>
							</div>
							<div class="tbl_absence">
								<samp>{{'AssociatesList.Absence' | translate}}</samp>
								<span>{{asso.absence}}</span>
							</div>
							<div class="tbl_paid">
								<samp>{{'AssociatesList.PaidHoliday' | translate}}</samp>
								<span>{{asso.paidHoliday}}</span>
							</div>
							<div class="tbl_contract">
								<samp>{{'AssociatesList.ContractTerm' | translate}}</samp>
								<span>{{asso.contractTerm}}</span>
							</div>
							<div class="tbl_download">
								<samp>{{'AssociatesList.SUM' | translate}}</samp>
								<button class="btn btn-primary btn-sm" (click)="createSingleAll(asso.userIdOrg, asso.userCode)">
									<i class="bi bi-download"></i>
								</button>
							</div>
								<div class="tbl_ledger">
									<samp>{{'AssociatesList.LEDGER' | translate}}</samp>
									<button class="btn btn-primary btn-sm" (click)="dwnLedgerPdf(asso)"><i class="bi bi-file-earmark-pdf"></i></button>
								</div>
							</ng-container>
							<ng-container *ngIf="adminLevel > 0">
								<div class="tbl_admin_company">
									<samp>会社名</samp>
									<span>{{item.customerName}}</span>
								</div>
								<div class="tbl_admin_office">
									<samp>部課名</samp>
									<span>{{item.customerOfficeName}}</span>
								</div>
								<div class="tbl_admin_ucode">
									<samp>登録番号</samp>
									<span>{{asso.userCode}}</span>
								</div>
								<div class="tbl_name">
									<samp>{{'AssociatesList.Name' | translate}}</samp>
									<a href="client-timesheet/{{asso.timesheetID}}/{{asso.userId}}" class="dlt_link">{{asso.userName}}</a>
								</div>
								<div class="tbl_notsubmit">
									<samp>{{'AssociatesList.NOTSUBMIT' | translate}}</samp>
									<span>{{asso.notSubmit}}</span>
								</div>
								<div class="tbl_submit">
									<samp>{{'AssociatesList.SUBMIT' | translate}}</samp>
									<span>{{asso.submit}}</span>
								</div>
								<div class="tbl_reject">
									<samp>{{'AssociatesList.REJECT' | translate}}</samp>
									<span>{{asso.reject}}</span>
								</div>
								<div class="tbl_approve">
									<samp>{{'AssociatesList.APPROVE' | translate}}</samp>
									<span>{{asso.approve}}</span>
								</div>
								<div class="tbl_contract">
									<samp>{{'AssociatesList.ContractTerm' | translate}}</samp>
									<span>{{asso.contractTerm}}</span>
								</div>
								<div class="tbl_download">
									<samp>{{'AssociatesList.SUM' | translate}}</samp>
									<button class="btn btn-primary btn-sm" (click)="createSingleAll(asso.userIdOrg, asso.userCode)">
										<i class="bi bi-download"></i>
									</button>
								</div>
								<div class="tbl_ledger">
									<samp>{{'AssociatesList.LEDGER' | translate}}</samp>
									<button class="btn btn-primary btn-sm" (click)="dwnLedgerPdf(asso)"><i class="bi bi-file-earmark-pdf"></i></button>
								</div>
							</ng-container>
						</article>
					</section>
				</div>
			</ng-container>
		</ng-container>
		
		<!-- Footer Totals -->
		<div class="associate_footer">
			<section>
				<article>
					<ng-container *ngIf="adminLevel === 0">
						<div class="tbl_section">&nbsp;</div>					
						<div class="tbl_ucode">&nbsp;</div>						
						<div class="tbl_name">{{'TOTAL' | translate}}</div>
						<div class="tbl_regular">{{totalRegular}}</div>
						<div class="tbl_overtime">{{totalOverTime}}</div>
						<div class="tbl_midnight">{{totalMn}}</div>
						<div class="tbl_total">{{overAllTotal}}</div>
						<div class="tbl_notsubmit">{{totalNotSubmit}}</div>
						<div class="tbl_submit">{{totalSubmit}}</div>
						<div class="tbl_reject">{{totalReject}}</div>
						<div class="tbl_approve">{{totalApprove}}</div>
						<div class="tbl_home">{{totalHome}}</div>
						<div class="tbl_absence">{{totalAbsence}}</div>
						<div class="tbl_paid">{{totalPh}}</div>
						<div class="tbl_contract">&nbsp;</div>
						<div class="tbl_download">
							<button class="btn btn-primary btn-sm" (click)="createSingleAll('-1', 'All')" [disabled]="!associatesList.length">{{'All' | translate}}</button>
						</div>
						<div class="tbl_ledger">&nbsp;</div>
					</ng-container>
					<ng-container *ngIf="adminLevel > 0">
						<div class="tbl_admin_company">&nbsp;</div>
						<div class="tbl_admin_office">&nbsp;</div>
						<div class="tbl_admin_ucode">&nbsp;</div>
						<div class="tbl_name">&nbsp;</div>
						<div class="tbl_notsubmit">{{totalNotSubmit}}</div>
						<div class="tbl_submit">{{totalSubmit}}</div>
						<div class="tbl_reject">{{totalReject}}</div>
						<div class="tbl_approve">{{totalApprove}}</div>
						<div class="tbl_contract">&nbsp;</div>
						<div class="tbl_download">
							<button class="btn btn-primary btn-sm" (click)="createSingleAll('-1', 'All')" [disabled]="!associatesList.length">{{'All' | translate}}</button>
						</div>
						<div class="tbl_ledger">&nbsp;</div>
					</ng-container>
				</article>
			</section>
		</div>
		
		<!-- PrimeNG Paginator -->
		<div class="paginator-row">
			<span class="paginator-note" *ngIf="!isMobileView">
				<ng-container *ngIf="lang === 'jp'">※「全て」ボタンは、ページに関係なく全スタッフのデータを出力します。</ng-container>
				<ng-container *ngIf="lang !== 'jp'">* The "All" button outputs data for all staff, regardless of pages.</ng-container>
			</span>
			<div class="paginator-wrap">
				<p-paginator 
					[rows]="itemsPerPage"
					[totalRecords]="getTotalAssociatesCount()"
					[showCurrentPageReport]="true"
					[currentPageReportTemplate]="getPaginatorTemplate()"
					(onPageChange)="onPageChange($event)">
				</p-paginator>
			</div>
		</div>

<!-- Timesheet Temporary Notice -->
<!-- <div class="email-notice-box timesheet-temp-notice">
  <div class="email-notice-box__text">
    <strong class="timesheet-temp-notice__title">※タイムシートのご確認をお願いいたします。</strong>
    <p>
7月分のタイムシートについて、7/20(月・祝)の勤怠レコードに通常の勤務時間が初期設定されていました。
スタッフが報告していない勤怠レコードについてはデータをクリアさせていただきました。<br />
既に報告済みあるいはご承認済みの場合には、<span class="red">7/20分の報告内容が正しいかどうかをご確認くださいますようお願いいたします。</span>
    </p>
  </div>
</div> -->

		<!-- Email Notice Box -->
		<div class="email-notice-box" *ngIf="adminLevel === 0">
			<div class="email-notice-box__body">
				<strong class="email-notice-box__label">{{'EMAIL_NOTICE_HEADING' | translate}}</strong>
				<div class="email-notice-box__text">
					<p>{{'EMAIL_NOTICE_LINE1' | translate}}</p>
					<p>{{'EMAIL_NOTICE_LINE2' | translate}}</p>
					<p><small>{{'EMAIL_NOTICE_LINE3' | translate}}</small></p>
				</div>
			</div>
			<p class="email-notice-box__email"><strong>{{'EMAIL_NOTICE_CURRENT' | translate}}　{{ userEmail2 }}</strong></p>
			<p class="email-notice-box__password"><strong>{{'PASSWORD_LIMIT' | translate}}　{{ passwordExpiryDate }}</strong></p>
		</div>
		
	</div>
	<!--  ############### Data Table End ################# -->
	
</div>
<!--  ############### Middle Containt Area End ################# -->